/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./alert-message";
import * as i2 from "ionic-angular/navigation/nav-controller";
import * as i3 from "ionic-angular/navigation/nav-params";
var styles_AlertMessagePage = [];
var RenderType_AlertMessagePage = i0.ɵcrt({ encapsulation: 2, styles: styles_AlertMessagePage, data: {} });
export { RenderType_AlertMessagePage as RenderType_AlertMessagePage };
export function View_AlertMessagePage_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 2, "div", [["role", "alert"], ["style", "width: 100%"]], [[8, "className", 0]], null, null, null, null)), (_l()(), i0.ɵeld(1, 0, null, null, 0, "i", [["class", "mdi mdi-information"]], null, null, null, null, null)), (_l()(), i0.ɵted(2, null, [" ", "\n"]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = i0.ɵinlineInterpolate(1, "alert alert-", _co.style, ""); _ck(_v, 0, 0, currVal_0); var currVal_1 = _co.message; _ck(_v, 2, 0, currVal_1); }); }
export function View_AlertMessagePage_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "page-alert-message", [], null, null, null, View_AlertMessagePage_0, RenderType_AlertMessagePage)), i0.ɵdid(1, 49152, null, 0, i1.AlertMessagePage, [i2.NavController, i3.NavParams], null, null)], null, null); }
var AlertMessagePageNgFactory = i0.ɵccf("page-alert-message", i1.AlertMessagePage, View_AlertMessagePage_Host_0, { style: "style", message: "message" }, {}, []);
export { AlertMessagePageNgFactory as AlertMessagePageNgFactory };
//# sourceMappingURL=alert-message.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/alert-message/alert-message.ngfactory.js
// module id = null
// module chunks = 